import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

const TableLoader = () => {
  return (
    <Stack gap="2px" width="100%">
      <Box display="flex" gap="2px">
        {[...Array(2)].map(() => {
          return (
            <Skeleton
              key={uuidv4()}
              variant="rectangular"
              animation="wave"
              width="100%"
              height={45}
            />
          );
        })}
      </Box>
      {[...Array(2)].map(() => {
        return (
          <Box display="flex" gap="2px" key={uuidv4()}>
            {[...Array(2)].map(() => {
              return (
                <Skeleton
                  key={uuidv4()}
                  variant="rectangular"
                  animation="wave"
                  width="100%"
                  height={37}
                />
              );
            })}
          </Box>
        );
      })}
      <Skeleton variant="rounded" animation="wave" height={52} />
    </Stack>
  );
};

export default TableLoader;
